import React from 'react';

export const SpacingAirPortal = () => {
  return <div id="spacing-air" data-cy="spacing-air" />;
};
